// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"61d90d9a","453":"204ad602"}[chunkId] + ".chunk.js";
};